import React from 'react';
import { HuchaValues } from '../../models/hucha-values';
import HuchaBonusCard from './hucha-bonus-card/hucha-bonus-card';
import RenovadoresBonusCard from './renovadores-bonus-card/renovadores-bonus-card';

export const HuchaCard = ({ huchaValues }: { huchaValues: HuchaValues | null }): React.ReactElement => {
	if (huchaValues?.isRenovador) {
		return <RenovadoresBonusCard huchaValues={huchaValues} />;
	}
	return <HuchaBonusCard huchaValues={huchaValues} />;
};
